import React from "react";

const QuestionHeaders = ({ setRequestStep, currentStep, translationMap }) => {

  const steps = [
  { stepNumber: 1, label: translationMap?.welcomeQuestionHeaders },
  { stepNumber: 2, label: translationMap?.generalQuestions },
  { stepNumber: 3, label: translationMap?.haveYou },
  { stepNumber: 4, label: translationMap?.healthQuestions },
  { stepNumber: 5, label: translationMap?.recentMonths },
  { stepNumber: 6, label: translationMap?.consent }];


  return (
    <>
      <div className="Title_Inner_Box">
        <h6 className="MainTitleOne">{translationMap?.makeBloodDonation}</h6>
      </div>
      <div className="Step_ul_main_box">
        <ul className="Step_Info_ul_box">
          {steps.map(({ stepNumber, label }) => {
            const isCompleted = stepNumber < currentStep;
            const isActive = stepNumber === currentStep;

            return (
              <li key={stepNumber}>
                <div
                  className={`Step_inner_box ${
                  isCompleted ?
                  "completed_box" :
                  isActive ?
                  "edit_box_border active_box" :
                  ""}`
                  }>
                  
                  <div
                    className={`inner_counter_wrap ${
                    isCompleted ? "inner_counter_wrap_filled" : ""}`
                    }>
                    
                    <span className="count_box">
                      {isCompleted ?
                      <i className="material-symbols-outlined">check</i> :

                      stepNumber
                      }
                    </span>
                    <p>{label}</p>
                  </div>
                  {isCompleted &&
                  <div className="inner_counter_wrap inner_counter_wrap2">
                      <div className="count_box">
                        {stepNumber}
                        <span className="green_circle">
                          <i className="material-symbols-outlined">check</i>
                        </span>
                      </div>
                      <p onClick={() => setRequestStep(stepNumber + 1)}>Edit</p>
                    </div>
                  }
                </div>
              </li>);

          })}
        </ul>
      </div>
    </>);

};

export default QuestionHeaders;